import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useCurrentClient } from '../../../api/clients'
import EditClientInfoButton from '../ClientInfoModal/EditClientInfoButton'

const useStyleVariant = (className, style, variant) => {
  return useMemo(() => {
    if (variant === 'wheel') {
      return [clsx(className, 'flex flex-col gap-sm items-center'), style]
    }
    return [className, style]
  }, [className, style, variant])
}

function EditCurrentClientInfo ({ children, className, style, variant }) {
  const { data: client, isLoading } = useCurrentClient()
  const [_className, _style] = useStyleVariant(className, style, variant)

  if (isLoading) {
    return (
      <div className={_className} style={_style}>
        {children}
      </div>
    )
  }

  return (
    <EditClientInfoButton client={client} className={_className} style={_style}>
      {children}
    </EditClientInfoButton>
  )
}

EditCurrentClientInfo.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  variant: PropTypes.oneOf(['wheel', 'none'])
}

EditCurrentClientInfo.defaultProps = {
  variant: 'none'
}

export default EditCurrentClientInfo
